"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.function.name");require("core-js/modules/web.dom.iterable");require("core-js/modules/es6.object.keys");

































var _aliOss = _interopRequireDefault(require("@/utils/aliOss")); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { getToken } from 'api/qiniu'
var _default = { name: 'EditorSlideUpload', props: { color: { type: String, default: '#1890ff' }, path: { type: String, default: 'robot' } }, data: function data() {return { dialogVisible: false, listObj: {}, fileList: [] };}, methods: { fnUploadRequest: function fnUploadRequest(option) {_aliOss.default.ossUploadFile(option, this.$props.path);}, checkAllSuccess: function checkAllSuccess() {var _this = this;return Object.keys(this.listObj).every(function (item) {return _this.listObj[item].hasSuccess;});}, handleSubmit: function handleSubmit() {var _this2 = this;var arr = Object.keys(this.listObj).map(function (v) {return _this2.listObj[v];});if (!this.checkAllSuccess()) {this.$message('Please wait for all images to be uploaded successfully. If there is a network problem, please refresh the page and upload again!');return;}this.$emit('successCBK', arr);
      this.listObj = {};
      this.fileList = [];
      this.dialogVisible = false;
    },
    handleSuccess: function handleSuccess(response, file) {
      var uid = file.uid;
      var objKeyArr = Object.keys(this.listObj);
      for (var i = 0, len = objKeyArr.length; i < len; i++) {
        if (this.listObj[objKeyArr[i]].uid === uid) {
          var imageUrl = 'https://cdn-tech.cozzia.com.cn/' + response.name;
          this.listObj[objKeyArr[i]].url = imageUrl;
          this.listObj[objKeyArr[i]].hasSuccess = true;
          return;
        }
      }
    },
    handleRemove: function handleRemove(file) {
      var uid = file.uid;
      var objKeyArr = Object.keys(this.listObj);
      for (var i = 0, len = objKeyArr.length; i < len; i++) {
        if (this.listObj[objKeyArr[i]].uid === uid) {
          delete this.listObj[objKeyArr[i]];
          return;
        }
      }
    },
    beforeUpload: function beforeUpload(file) {
      var _self = this;
      var _URL = window.URL || window.webkitURL;
      var fileName = file.uid;
      this.listObj[fileName] = {};
      return new Promise(function (resolve, reject) {
        var img = new Image();
        img.src = _URL.createObjectURL(file);
        img.onload = function () {
          _self.listObj[fileName] = { hasSuccess: false, uid: file.uid, width: this.width, height: this.height };
        };
        resolve(true);
      });
    } } };exports.default = _default;